import SubstituteProductsReducer, {
    SubstituteProductsActions,
} from "@store/Framework/Store/Store/Components/SubstituteProducts/SubstituteProductsReducer";
import { combineReducers } from "redux";

const componentsReducers = {
    substituteProducts: SubstituteProductsReducer,
};

export type StoreComponentsActions = SubstituteProductsActions;
export default combineReducers(componentsReducers);
